export default __webpack_public_path__ + "static/media/app-store-icon.0ea15932.svg";